export default function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => {
      if (ref.hasOwnProperty('current')) ref.current = node;
      else ref(node);
    });
  };
}
